import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';

const root = document.getElementById('fundCenter') || document.getElementById('kurtosysDocLibrary');
const { src = '' } = root.nextElementSibling as HTMLScriptElement;

const renderApp = (intlSupported) => {
    ReactDOM.render(
        // Set intlSupported prop
        // Spread data-attributes from root element as props
        // Pass script tag src as prop
        <App 
            intlSupported={intlSupported} 
            scriptSrc={src}
            {...root.dataset} 
        />,
        root
    );
};

// Dynamic import Intl polyfill
const loadIntlPolyfill = async () => {
    await import(/* webpackChunkName: "intl" */ 'intl');
};

// Load Intl polyfill where required then render app
if (!(window as any).Intl) {
    console.info('Intl API unsupported');
    loadIntlPolyfill();
    renderApp(false);
} else {
    console.info('Intl API supported');
    renderApp(true);
}


// WEBPACK FOOTER //
// ./src/index.tsx